<!-- @format -->

<ng-container *ngFor="let studyEvent of sortedEvents; trackBy: entityId">
  <span *ngIf="sortedEvents.length > 1" class="d-inline-block">
    {{ studyEvent.name | localizedString }}
  </span>
  <app-study-event-info [studyEvent]="studyEvent" [teacherIds]="teacherIds"></app-study-event-info>
</ng-container>
